var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { RES } from '@pawgame/laya-game-sdk';
import pako from 'pako';
import { getVersionURL } from './getVersionURL';
let data;
export function loadConfig() {
    return __awaiter(this, void 0, void 0, function* () {
        return new Promise((resolve, reject) => {
            const uri = getVersionURL('res/config/config.dat');
            RES.load([{ url: uri, type: Laya.Loader.BUFFER }]).then((res) => {
                if (res) {
                    const rawData = Laya.loader.getRes(uri);
                    const content = pako.inflate(new Uint8Array(rawData), { to: 'string' });
                    data = JSON.parse(content);
                    resolve(data);
                }
                else {
                    reject(res);
                }
            });
        });
    });
}
export const getConfig = (name) => {
    return data[name];
};
//# sourceMappingURL=Config.js.map